import { Navigate, useLocation } from 'react-router-dom';

const LEGACY_PREFIX = '/workforce-planning';
const PERSONNEL_BUDGETING_PREFIX = '/personnel-budgeting';

/**
 * Pathname from an href, before the browser or the router decodes it.
 * `useParams` turns `%3F` into `?` and the redirect then splits the path.
 */
export function pathnameFromHref(href: string, origin: string): string | null {
  if (!href.startsWith(origin)) return null;
  let rest = href.slice(origin.length);
  const hashAt = rest.indexOf('#');
  if (hashAt !== -1) rest = rest.slice(0, hashAt);
  const queryAt = rest.indexOf('?');
  if (queryAt !== -1) rest = rest.slice(0, queryAt);
  return rest.length > 0 ? rest : '/';
}

export function encodedPathnameForRedirect(
  routerPathname: string,
  href: string,
  origin: string
): string {
  const fromBrowser = pathnameFromHref(href, origin);
  if (fromBrowser == null) return routerPathname;
  try {
    if (decodeURIComponent(fromBrowser) === routerPathname) return fromBrowser;
  } catch {
    return routerPathname;
  }
  return routerPathname;
}

/** Bookmark redirect. The suffix keeps the original encoding and case. */
export function redirectLegacyWorkforcePlanning(
  encodedPathname: string,
  search: string,
  hash: string
): string {
  const lower = encodedPathname.toLowerCase();
  const rest = legacyRest(encodedPathname, lower);
  const suffix = rest === '/' ? '' : rest;
  return `${PERSONNEL_BUDGETING_PREFIX}${suffix}${search}${hash}`;
}

function legacyRest(encodedPathname: string, lower: string): string {
  if (lower === LEGACY_PREFIX) return '';
  if (lower.startsWith(`${LEGACY_PREFIX}/`)) return encodedPathname.slice(LEGACY_PREFIX.length);
  return '';
}

/** Sends bookmarks on the old shell mount to the personnel-budgeting path. */
export function LegacyWorkforcePlanningRedirect() {
  const { pathname, search, hash } = useLocation();
  const encodedPathname = encodedPathnameForRedirect(
    pathname,
    window.location.href,
    window.location.origin
  );
  return <Navigate to={redirectLegacyWorkforcePlanning(encodedPathname, search, hash)} replace />;
}
